import { type ComponentType, type ReactNode } from 'react'
import { IconButton } from '@/components/IconButton'
import { useInfoPanelContext } from '@/features/jobs/details/tax-type/tax-prep-organizer/components/InfoPanel/InfoPanelContext'
import styles from './FormFieldInfoPanelLabel.module.css'
import { FormFieldRequiredLabel } from '../FormFieldRequiredLabel'

interface FieldLabelProps {
  label: ReactNode
  infoContent: ComponentType<object>
  required?: boolean
  infoTestId?: string
}

export function FormFieldInfoPanelLabel({
  label,
  required = false,
  infoContent,
  infoTestId,
}: FieldLabelProps) {
  const { toggleInfoPanel } = useInfoPanelContext()

  return (
    <div className={styles.fieldLabel}>
      <FormFieldRequiredLabel label={label} required={required} />
      <span className={styles.infoButton}>
        <IconButton
          name="info"
          sm
          label="More information"
          onPress={() => toggleInfoPanel(infoContent)}
          testId={infoTestId}
        />
      </span>
    </div>
  )
}
